/**
 * @file   detect.js 容器检测器
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2021-01-04
 * @doc    https://console.cloud.baidu-int.com/devops/icode/repos/baidu/exp-fe/utils/blob/master:src/browser.js
 */

import {browser} from '@baidu/exp-utils';

export const IS_IOS = browser.IS_IOS;
export const IS_ANDROID = browser.IS_ANDROID;
export const IS_GEM_APP = (/fcapp/i).test(browser.USER_AGENT);
export const IS_BAIDU = browser.IS_BAIDU;
export const IS_WECHAT = browser.IS_WECHAT;
// 是否是QQ浏览器
export const IS_QQ_BROWSER = browser.IS_QQ_BROWSER;
// 是否是QQ内置浏览器
export const IS_QQ = browser.IS_QQ;
export const IS_VIVO = browser.IS_VIVO;
export const IS_OPPO = browser.IS_OPPO;
export const IS_MIUI = browser.IS_MIUI;
export const IS_SAMSUNG = browser.IS_SAMSUNG;
export const IS_JINLI = browser.IS_JINLI;
export const IS_MEIZU = browser.IS_MEIZU;
export const IS_LETV = browser.IS_LETV;
// 是否在小程序环境中
export const IS_SWAN = /swan\//.test(window.navigator.userAgent) || /^webswan-/.test(window.name);
